export default __webpack_public_path__ + "static/media/Mint_day_v6.1ba357a2.jpg";